var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 8,
    viewBox: "0 0 38 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.125C1.85938 0.125 0.125 1.85938 0.125 4C0.125 6.14062 1.85938 7.875 4 7.875C6.14062 7.875 7.875 6.14062 7.875 4C7.875 1.85938 6.14062 0.125 4 0.125ZM14 0.125C11.8594 0.125 10.125 1.85938 10.125 4C10.125 6.14062 11.8594 7.875 14 7.875C16.1406 7.875 17.875 6.14062 17.875 4C17.875 1.85938 16.1406 0.125 14 0.125ZM24 0.125C21.8594 0.125 20.125 1.85938 20.125 4C20.125 6.14062 21.8594 7.875 24 7.875C26.1406 7.875 27.875 6.14062 27.875 4C27.875 1.85938 26.1406 0.125 24 0.125ZM34 0.125C31.8594 0.125 30.125 1.85938 30.125 4C30.125 6.14062 31.8594 7.875 34 7.875C36.1406 7.875 37.875 6.14062 37.875 4C37.875 1.85938 36.1406 0.125 34 0.125Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.4c961e88.svg";
export { ForwardRef as ReactComponent };